module.exports = __webpack_public_path__ + "static/media/title.20e1b324.png";